import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ajax from './http/ajax'
import prepare from './components/Prepare'
import 'utils/rem'
import 'vant/lib/index.css'
import './assets/sprites/sprite.css'
import 'lib-flexible'
import filters from 'utils/filters'
import VueClipboard from 'vue-clipboard2'
import NativeStorage from './utils/storageTime'
import Vconsole from 'vconsole'
import 'smcommon/common/smcommon.css'
import env from './api/api.env'

// import { sentry } from 'fengche-utils'
// import { APP_VERSION } from './api/api.constants.js'
import registDirectives from 'utils/directive'
import {
    Loading,
    Toast,
    Button,
    Icon,
    // Sku,
    Lazyload,
    Image,
    Field,
    Grid,
    GridItem,
    Cell,
    CellGroup,
    Dialog,
    Overlay,
    Search,
    Popup,
    ActionSheet,
} from 'vant'

// 忽略跳转小程序组件报错问题
Vue.config.ignoredElements = ['wx-open-launch-weapp']

// if (process.env.NODE_ENV === 'production' && env === 'release') {
//     const option = {
//         dsn: '//2353a15383fc4c7eba39ce3ea7906cab@sentry.carisok.cn/6',
//         release: APP_VERSION,
//         environment: process.env.NODE_ENV,
//     }
//     const Sentry = sentry.getInstance(Vue, option)
//     Vue.prototype.$sentry = Sentry
// }

Vue.prototype.$setgoindex = function () {   // 给初始进入的页面加上has_history参数
    if (window.history.length <= 1) {
        if (location.href.indexOf('?') === -1) {
            window.location.href = location.href + '?has_history=true'
        } else if (location.href.indexOf('?') !== -1 && location.href.indexOf('has_history') === -1) {
            window.location.href = location.href + '&has_history=true'
        }
    }
}

Vue.prototype.goBack = function () {   // 点击返回按钮处罚的事件
    if (this.$route.query.has_history === 'true') {
        this.$router.push('/')
    } else {
        this.$router.back(-1)
    }
}

if (process.env.NODE_ENV === 'production' && env !== 'release') {
    new Vconsole() // eslint-disable-line
}
registDirectives(Vue)
Vue.$store = store
Vue.$router = router
Vue.config.productionTip = false
Vue.$storage = new NativeStorage()
Vue.prototype.$ajax = ajax

// Vue.prototype.storage.setLocalConfig = setLocalConfig
// Vue.prototype.storage.getLocalConfig = getLocalConfig
Vue.use(Button)
Vue.use(Icon)
// Vue.use(Sku)
Vue.use(Lazyload)
Vue.use(Image)
Vue.use(Field)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Dialog)
Vue.use(VueClipboard)
Vue.use(Toast)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Search)
Vue.use(Popup)
Vue.use(ActionSheet)

prepare(Vue)
filters(Vue)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
